import React from 'react';
import { Stepper, Step, StepLabel, RaisedButton, FontIcon } from 'material-ui';
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import supplierWizardCompleteImage from '../../../../../../www/images/supplier-wizard-complete.svg';

const NewDraftProgressIndicator = ({ errors, openPublishConfirmation }) => {
  const firstStepCompleted = !errors.errorExist;
  return (
    <Stepper activeStep={firstStepCompleted ? 2 : 1}>
      <Step completed>
        <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
          <div style={{ textAlign: 'center' }}>
            Create Rate Template
          </div>
        </StepLabel>
      </Step>
      <Step completed={firstStepCompleted}>
        <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
          <div style={{ textAlign: 'center' }}>
            Enter Rates & Required Information
          </div>
        </StepLabel>
      </Step>
      <Step>
        <StepLabel style={{ height: '32px' }}>
          <div style={{ textAlign: 'center', width: '100%', display: 'flex', alignItems: 'center' }}>
            <span style={{ width: '68px' }}>Review &</span>
            {
              firstStepCompleted ? (
                <RaisedButton
                  secondary
                  label="Finalise Template"
                  labelStyle={{ padding: '0 4px', textTransform: 'none' }}
                  style={{ marginLeft: '4px', width: '140px' }}
                  onTouchTap={openPublishConfirmation}
                />
              ) : 'Finalise'
            }
          </div>
        </StepLabel>
      </Step>
      <Step completed={false}>
        <StepLabel style={{ height: '32px', paddingRight: 0 }}>
          <div style={{ textAlign: 'center' }}>
            Send Rates to Partners
          </div>
        </StepLabel>
      </Step>
    </Stepper>
  );
};

export default NewDraftProgressIndicator;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/progressIndicatorBar/newDraft.jsx